import { store } from '../../../../../resources/frontend/js/store';

export default (id) => {
    if (typeof id === 'number') {
        return store.state.quiz.questionsData[id - 1];
    }

    return store.state.quiz.questionsData.find(question => question._info.uuid === id);
};
